/* eslint-disable comma-spacing */
<template>
  <v-container fluid class="delivery px-0 py-2">
    <v-layout>
      <v-flex xs12 sm10 offset-sm1 md12 offset-md0 v-if="loaded">
        <v-alert type="error" v-model="noFunds" v-if="isCourier() && !haveFunds() && getStatus().id === 2">
          Nemate dovoljno sredstava da se prijavite za dostavu
        </v-alert>
        <v-alert outline class="font-weight-black title" type="error" :value="true" v-if="getStatus().id === 1">
          Dostava je otkazana
        </v-alert>
        
        <v-card :class="getStatus().name" class="delivery-card">

          <!-- Change delivery status: apply, pickup, delivered, cancel -->
          <v-card tile flat class="d-flex justify-space-between py-2" v-if="expanded">
            <v-btn class="primary mb-0" large @click="apply" v-if="isCourier() && haveFunds() && [2,3].includes(getStatus().id)">prijavi se</v-btn>
            <v-btn class="primary mb-0" large @click="pickup" v-if="ownDelivery() && [4,5].includes(getStatus().id)">dostava preuzeta</v-btn>
            <v-btn class="primary mb-0" large @click="delivered" v-if="ownDelivery() && isCourier() && [6,7].includes(getStatus().id)">gotova dostava</v-btn>
            <v-btn class="secondary mb-0" large @click="cancelDialog=true"
                v-if="(isCourier() && [4,5].includes(getStatus().id)) || (isStore() && [2,3,4,5].includes(getStatus().id))">
              otkaži dostavu
            </v-btn>
          </v-card>

          <!-- timeline -->
          <v-card flat class="delivery-party pa-2" v-if="expanded">
            <v-stepper alt-labels>
              <v-stepper-header>
                <v-stepper-step :complete="getStatus().id > 2" step="1">
                  <p class="text-xs-center">zahtev</p>
                  <p class="text-xs-center">{{formatDate(delivery.time_created)}}</p>
                </v-stepper-step>
                <v-divider></v-divider>
                <!-- <v-stepper-step v-if="getStatus().id === 1" :rules="[() => false]" step="6">
                  otkazano
                </v-stepper-step>
                <v-divider v-if="getStatus().id === 1"></v-divider> -->
                <v-stepper-step :complete="getStatus().id > 3" step="2">
                  <p class="text-xs-center">prijava</p>
                  <p class="text-xs-center">{{formatDate(delivery.time_accepted)}}</p>
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="getStatus().id > 5" step="3">
                  <p class="text-xs-center">preuzimanje</p>
                  <p class="text-xs-center">{{formatDate(delivery.time_picked_up)}}</p>
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="getStatus().id > 7" step="4">
                  <p class="text-xs-center">dostava</p>
                  <p class="text-xs-center">{{formatDate(delivery.time_delivered)}}</p>
                </v-stepper-step>
              </v-stepper-header>
            </v-stepper>
          </v-card>

          <!-- delivery info: store, courier, destination, description -->
          <v-card flat class="delivery-party pa-2">
            <v-card-text class="delivery-party px-2 pt-0 pb-2">
              <p class="subheading"><v-icon class="mr-2">fa-sign-out-alt</v-icon>radnja</p>
              <span class="text-xs-left delivery-left-col title">
                <strong>{{delivery.from_name}}, {{delivery.from_address}}</strong>
              </span>
              <span class="text-xs-right delivery-right-col subheading">
                {{formatDate(delivery.time_targeted_pickup, true)}}<v-icon class="ml-1">fa-clock</v-icon>
              </span>
            </v-card-text>
          </v-card>
          <v-card flat class="delivery-party pa-2">
            <v-card-text class="delivery-party px-2 pt-0 pb-2" v-if="delivery.courier_id">
              <span class="my-1 text-xs-left delivery-left-col subheading">
                <v-icon>fa-user-astronaut</v-icon>
                dostavljač
              </span>
              <span class="text-xs-left delivery-left-col title">
                <strong>{{delivery.courier_name}}<i v-if="delivery.agency_name">,</i> {{delivery.agency_name}}</strong>
                <v-tooltip right>
                  <v-icon slot="activator" class="ma-0 ml-2" @click.prevent="openAssignDialog()"
                          v-if="isAssignable()"
                          v-bind:class="{'isPendingPickup': !isAssigned()}">
                      fa-share
                  </v-icon>
                  <span>dodeli</span>
                </v-tooltip>
              </span>
            </v-card-text>
          </v-card>
          <v-card flat class="delivery-party pa-2">
            <v-card-text class="delivery-party px-2 pt-0 pb-2">
              <p class="subheading"><v-icon class="mr-2">fa-sign-in-alt</v-icon>odredište</p>
              <span class="text-xs-left delivery-left-col title">
                <strong><span v-if="delivery.to_name">{{delivery.to_name}}, </span>{{delivery.to_address}}</strong>
              </span>
              <span class="text-xs-right delivery-right-col subheading">
                {{formatDate(delivery.time_targeted_delivery, true)}}<v-icon class="ml-1">fa-clock</v-icon>
              </span>
            </v-card-text>
          </v-card>
          <v-card flat class="delivery-party pa-2" v-if="delivery.description">
            <v-card-text class="delivery-party px-2 pt-0 pb-2">
              <p>{{delivery.description}}</p>
            </v-card-text>
          </v-card>

          <!-- Messages -->
          <v-card flat class="delivery-party pa-2" v-if="expanded">
            <v-btn class="primary" large block @click="toggleComments()">
              <v-spacer></v-spacer>
              <v-icon class="mr-1">question_answer</v-icon>Poruke ({{comments.length}})
              <v-spacer></v-spacer>
              <v-icon class="right" v-if="showComments">keyboard_arrow_down</v-icon>
              <v-icon class="right" v-if="!showComments">keyboard_arrow_right</v-icon>
            </v-btn>
            <v-card class="mb-1" v-if="showComments">
              <v-card class="ma-0 pa-3" v-for="(comment, i) in comments" :key="i"
                :class="{'text-xs-left': ownComment(comment), 'text-xs-right': !ownComment(comment)}">
                <div class="card-title body-2">
                  {{comment.user_name}}, {{formatDate(comment.created)}}
                </div>
                <v-divider></v-divider>
                <div class="card-content body-1">
                  {{comment.comment}}
                </div>
              </v-card>
              <v-card class="pa-3">
                <v-textarea v-model="newComment" placeholder="Unesite poruku" outline rows="3" auto-grow></v-textarea>
              </v-card>
              <v-btn large block class="primary" @click="submitComment()" :disabled="!this.newComment"><v-icon class="mr-1">add_comment</v-icon>Pošalji</v-btn>
            </v-card>

            <!-- Features for mobile phones: call -->
            <v-btn v-if="$mobileapp && isStore() && delivery.courier_phone"
                class="secondary" large block :href="'tel:' + delivery.courier_phone">
              <v-icon class="mr-1">phone</v-icon> Pozovi kurira
            </v-btn>
            <v-btn v-if="$mobileapp && isCourier() && delivery.requester_phone"
                class="secondary" large block :href="'tel:' + delivery.requester_phone">
              <v-icon class="mr-1">phone</v-icon> Pozovi radnju
            </v-btn>
            <v-btn v-if="$mobileapp && delivery.recipient_phone"
                class="secondary" large block :href="'tel:' + delivery.recipient_phone">
              <v-icon class="mr-1">phone</v-icon> Pozovi primaoca
            </v-btn>

            <!-- <v-btn class="secondary" large block @click="$router.back()">nazad</v-btn> -->

          </v-card>

          <!-- <v-flex xs12 sm6 offset-sm3 v-if="error"> -->
            <v-alert v-model="error" type="error">Dostava ne postoji ili ne učestvujete u njoj</v-alert>
          <!-- </v-flex> -->

          <v-card-actions :class="`delivery-status py-3 mt-1 subheading ${getStatus().name} ${getStatus().classes}`"
                          :key="delivery.id+statusRefresh">
            <v-icon class="mx-2">{{ getStatus().icon }}</v-icon>
            {{getStatus().label}}
            <v-spacer></v-spacer>
            {{delivery.nextEvent}}
            <v-spacer></v-spacer>
            <v-icon class="mx-2" @click.prevent="load()">fa-sync-alt</v-icon>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-dialog v-model="cancelDialog" max-width="600px">
        <v-form ref="cancelForm" v-model="cancelValid">
          <v-card>
            <v-card-actions>
              <v-btn color="primary" flat outline @click.stop="cancel('Kupac je otkazao')">Kupac je otkazao</v-btn>
              <v-btn color="primary" flat outline @click.stop="cancel('Ne mogu da stignem')">Ne mogu da stignem</v-btn>
              <v-btn v-if="isStore()" color="primary" flat outline @click.stop="cancel('Niko se nije prijavio')">Niko se nije prijavio</v-btn>
            </v-card-actions>
            <v-card-text>
              <v-textarea v-model="cancelReason" placeholder="Razlog otkazivanja" outline rows="3" auto-grow :rules="mandatory"></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" flat outline @click.stop="cancel()">Otkaži dostavu</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click.stop="cancelDialog=false">Zatvori</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog v-model="assignDialog" max-width="400px">
        <v-card>
          <v-card-title class="primary"><h4>Dodeli kuriru</h4></v-card-title>
          <v-divider></v-divider>
          <v-list dense>
            <v-list-tile v-for="(courier, j) in couriers" :key="j" @click="selectCourier(courier)" :class="{ accent : courier.selected }">
              <v-list-tile-content>
                <span v-bind:style="{color: courier.online == 0 ? 'gray' : 'inherit'}">
                  <span>{{ courier.name }}</span>
                  <span><v-btn fab dark small v-bind:color="courier.online ? 'green' : 'grey'">{{ courier.active_deliveries_count }}</v-btn></span>
                  <span>{{ courier.latest_address }}</span>
                  <i>{{ formatTimeCourier(courier.latest_event) }}</i>
                </span></v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-btn class="primary" block large @click.prevent="assignDelivery">Ok</v-btn>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
import 'moment/locale/sr'
import auth from '@/services/authService.js'
import deliveryService from '@/services/deliveryService'
import userService from '@/services/userService'

let refreshInterval
export default {
  props: ['id', 'delivery', 'expanded'],
  data () {
    return {
      // delivery: {},
      user: auth.getCurrentUser(),
      loaded: true,
      error: false,
      showComments: false,
      comments: [],
      newComment: '',
      cancelDialog: false,
      cancelReason: '',
      cancelValid: false,
      mandatory: [
        v => !!v || 'Obavezno polje'
      ],
      statusRefresh: 0,
      assignDialog: false,
      selectedCourier: null,
      couriers: userService.getCouriers()
    }
  },
  created () {
    // when loading component in single view load delivery by id
    if (!this.delivery && this.id) {
      this.delivery = {}
      this.load(this.id).then(() => {
        this.comments = deliveryService.getDeliveryComments(this.delivery.id)
      })
    } else {
      if (this.expanded) {
        this.comments = deliveryService.getDeliveryComments(this.delivery.id)
      }
    }
    // periodically bump statusRefresh which will force late-to-whatever status to update
    // and check for new comments
    refreshInterval = setInterval(() => {
      this.statusRefresh++
      if (this.expanded) {
        this.comments = deliveryService.getDeliveryComments(this.delivery.id)
      }
    }, 20000)
  },
  destroyed () {
    clearInterval(refreshInterval)
  },
  watch: {
    '$route' (to, from) {
      this.load()
    },
    expanded (to, from) {
      if (to) {
        this.comments = deliveryService.getDeliveryComments(this.delivery.id)
        this.$nextTick(() => this.$el.scrollIntoView({ behavior: 'smooth', block: 'center' }))
      }
    }
  },
  methods: {
    formatDate (d, asap) {
      return d ? moment(d).format('HH:mm') : (asap ? 'što pre' : '')
    },
    formatTimeCourier (d) {
      return d ? moment(d).format('HH:mm') : ''
    },
    load (id) {
      console.log('load', id)
      return deliveryService.getDelivery(id || this.delivery.id).then((delivery) => {
        if (delivery === null) {
          this.error = true
        } else {
          this.delivery = delivery
          this.loaded = true
        }
      }).catch((error) => {
        console.log(error)
        this.error = true
      })
    },
    isStore () {
      return this.user.id ? this.user.id === this.delivery.requester_id : false
    },
    isCourier () {
      return this.user.roles ? this.user.roles.indexOf('courier') !== -1 : false
    },
    ownDelivery () {
      return this.user.id === this.delivery.requester_id || this.user.id === this.delivery.courier_id
    },
    haveFunds () {
      return this.user.balance + this.user.credit > 10
    },
    getStatus () {
      return deliveryService.getDeliveryStatus(this.delivery)
    },
    apply () {
      deliveryService.applyForDelivery(this.delivery).then((response) => {
        this.load()
        let id = this.delivery.id
        setTimeout(() => { this.load(id) }, 1000)
        setTimeout(() => { this.load(id) }, 10000)
      })
    },
    pickup () {
      deliveryService.pickupDelivery(this.delivery).then((response) => {
        this.load()
      })
    },
    delivered () {
      deliveryService.finishDelivery(this.delivery).then((response) => {
        this.load()
      })
    },
    cancel (reason) {
      if (reason) {
        this.cancelReason = reason
      }
      this.$nextTick(() => {
        if (this.$refs.cancelForm.validate()) {
          deliveryService.cancelDelivery(this.delivery, this.cancelReason).then((response) => {
            this.cancelDialog = false
            this.cancelReason = ''
            this.load()
          })
        }
      })
    },
    toggleComments () {
      if (this.showComments) {
        this.showComments = false
      } else {
        this.showComments = true
        this.comments = deliveryService.getDeliveryComments(this.delivery.id)
      }
    },
    ownComment (comment) {
      return comment.user_id === this.user.id
    },
    submitComment () {
      deliveryService.postDeliveryComment(this.delivery.id, this.newComment).then(async (response) => {
        this.newComment = ''
        this.comments = deliveryService.getDeliveryComments(this.delivery.id)
      })
    },
    selectCourier (courier) {
      this.couriers.forEach(c => { c.selected = (c.id === courier.id && this.selectedCourier !== courier) })
      this.selectedCourier = this.selectedCourier !== courier ? courier : null
      this.$forceUpdate()
    },
    isAssignable () {
      return this.user.isProxy &&
        (this.delivery.courier_id === this.user.id || this.delivery.agency_id === this.user.id) &&
        this.getStatus().isActive && this.delivery.time_picked_up === null
    },
    isAssigned () {
      return this.delivery.courier_id !== this.user.id
    },
    openAssignDialog () {
      userService.getCouriersPromise().then(() => {
        this.assignDialog = true
        this.couriers.forEach(c => {
          if (c.id === this.delivery.courier_id) {
            this.selectedCourier = c
            c.selected = true
          } else {
            c.selected = false
          }
        })
      })
    },
    assignDelivery () {
      if (this.selectedCourier !== null) {
        let deliveryId = this.delivery.id
        deliveryService.assignDelivery(this.delivery, this.selectedCourier).then(() => {
          deliveryService.getDelivery(deliveryId)
          this.assignDialog = false
          this.selectedCourier = null
        }).catch(error => {
          console.log('assign delivery failed', error)
          userService.getCouriers()
        })
      } else {
        this.assignDialog = false
        this.selectedCourier = null
      }
    }
  },
  computed: {
    noFunds () {
      return this.isCourier() && !this.haveFunds() && [2, 3].includes(this.getStatus().id)
    }
  }
}
</script>

<style>
.delivery .v-stepper__step {
  flex-basis: 100px;
}
.delivery .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
  display: flex;
}
.delivery .v-stepper--alt-labels .v-stepper__header .v-divider {
  margin: 35px -50px 0;
}
.delivery-left-col {
  width: 67%;
  display: inline-block;
}
.delivery-right-col {
  width: 30%;
  display: inline-block;;
}

.delivery-comment {
  width: 80%;
}

</style>
